import { useQuery } from '@tanstack/vue-query'
import { useHttp } from '@/shared/lib'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

/**
 * Функция загрузки шапки для инвентаризационного объекта
 */
const useLoadInventory = () => {
  const http = useHttp()
  const route = useRoute()

  const url = computed(() => `/inventory/${route.params.object_id}`)

  const queryKey = computed(() => ['load_group', route.params.object_id])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}

export { useLoadInventory }
